export const isAdultProduct = PRODUCT_TYPE === 'adult';
export const isChildProduct = PRODUCT_TYPE === 'child';
export const productCurrentTheme = isAdultProduct?'dark':'light';
export const productCurrentPlatform = isAdultProduct?'pc':'mobile';